enum SpacingNumeric {
  Space1 = 4,
  Space2 = 8,
  Space3 = 12,
  Space4 = 16,
  Space5 = 20,
  Space6 = 24,
  Space7 = 28,
  Space8 = 32,
  Space9 = 36,
  Space10 = 40,
  Space11 = 44,
  Space12 = 48,
  Space16 = 64,
}

// Helper method for typed enum key mapping
function enumKeys<O extends object, K extends keyof O = keyof O>(object: O): K[] {
  return Object.keys(object).filter((k) => Number.isNaN(+k)) as K[]
}

const SpacingString = enumKeys(SpacingNumeric).reduce(
  (accumulator, spaceKey) => {
    accumulator[spaceKey] = SpacingNumeric[spaceKey] + 'px'

    return accumulator
  },
  {} as Record<keyof typeof SpacingNumeric, string>,
)

export { SpacingNumeric, SpacingString }
